export interface IReusableScreen
{
  canReuseScreen( opts: unknown ): boolean;
  onScreenHidden(): void;
  onScreenShown( opts: unknown ): void;
  setDomHidden( hidden: boolean, redraw?: boolean ): void;
  isDomMode(): boolean;
  render?(): void;
}

export function isReusableScreen( ui: unknown ): ui is IReusableScreen
{
  const u = ui as Partial<IReusableScreen> | null;
  return !!u
    && typeof u.canReuseScreen === "function"
    && typeof u.onScreenHidden === "function"
    && typeof u.onScreenShown === "function"
    && typeof u.setDomHidden === "function"
    && typeof u.isDomMode === "function";
}
